const MessagesList = {
  components: {
    autoLink: autoLink,
    uploader: UploaderMessage,
    ThreadTitle: _messageTitle,
  },
  data() {
    return {
      content: '',
      messages: [],
      defaultDateFormat: 'ddd D [de] MMMM',
    };
  },
  props: {
    thread: { default: false },
  },
  computed: {
    canWrite() {
      //si el thread no está abierto
      if (!['publish', 'archived'].includes(this.thread.status)) return false;
      //si son mensajes de perfil
      if (this.thread.origin === 'profiles') return true;

      const total = this.messages.filter((m) => m.type === 'text').length;

      //si está abierto y hay más de un mensaje
      if (total > 1) return true;
      //si solo hay uno, pero no es mio
      return total === 1 && !this.messages[0]?.mine;
    },
    closedMessage() {
      if (['publish', 'archived'].includes(this.thread.status)) {
        return false;
      }

      if (this.thread.origin === 'jobs') {
        return !['publish', 'inactive'].includes(this.thread.ref.job.status)
          ? 'Se ha cerrado la oferta de empleo'
          : 'Se ha retirado la inscripción';
      }

      const messages = {
        blocked: 'Has bloqueado esta conversación',
        spam: 'Has denunciado esta conversación',
        closed: 'Se ha cerrado la conversación',
        banned: 'Se ha bloqueado a este usuario',
      };

      return messages[this.thread.status];
    },
    user() {
      return domestiko.user;
    },
  },
  watch: {
    thread: function (thread) {
      //console.log('list.watch.thread', thread);
      this.fetch();
    },
    messages: function (value) {
      const list = UIkit.util.$('.messages-list');
      setTimeout(function () {
        list.scrollTop = list.scrollHeight;
      }, 100);
    },
  },
  created() {
    this.fetch();
    this.$ws.on('message.new', (message) => {
      //console.log('list.message.new', message);
      if (message.thread._id === this.thread._id) {
        this.messages.push(message);
      }
    });
    this.$ws.on('messages.update', (payload) => {
      //console.log('list.messages.update', payload);
      this.messages = payload.messages;
    });
  },
  methods: {
    fetch() {
      if (!this.thread) return;
      this.$ws.emit('messages.update', { thread: this.thread._id });
    },
    send(content) {
      if (!content) return;
      const message = {
        content,
        mine: true,
        status: 'sent',
        thread: this.thread._id,
        createdAt: new Date(),
      };
      //console.log('list.message.send', message);
      this.$emit('send', message);
      this.$ws.emit('message.new', message);
      this.messages.push(message);
      this.content = '';
    },
    upload(message) {
      message.mine = true;
      message.status = 'sent';
      //console.log('list.message.upload', message);
      this.messages.push(message);
      this.thread.updatedAt = new Date();
    },
    remove(message) {
      customConfirm(
        '¿Quieres borrar este mensaje?',
        'Una vez borrado este mensaje no podrá recuperarse',
      ).then(() => {
        message.status = 'deleted';
        this.$ws.emit('message.delete', message);
        //console.log(message, this.messages.indexOf(message));
      });
    },
    notify(action, $event) {
      this.thread.status = action;
      this.$ws.emit('thread.status', {
        thread: this.thread._id,
        status: action,
      });
      if (action !== 'publish') {
        this.$emit('reset');
      }
      UIkit.dropdown($event.target.closest('.uk-dropdown')).hide(false);
    },

    notifyAlert(action, $event) {
      const alert = {
        blocked: {
          title: 'Vas a bloquear la conversacion',
          content:
            'Si bloqueas la conversación no podrás volver a escribir en ella.',
        },
        spam: {
          title: 'Vas a denunciar la conversacion',
          content:
            'Si denuncias la conversación nuestros administradores investigarán el incidente. No podrás volver a escribir en ella.',
        },
        deleted: {
          title: 'Vas a eliminar la conversacion',
          content:
            'Si eliminas la conversación no podrás volver a escribir en ella.',
        },
      };

      if (Object.keys(alert).includes(action)) {
        customConfirm(alert[action].title, alert[action].content).then(() => {
          return this.notify(action, $event);
        });
      }
    },
    isDifferentDate(idx) {
      if (!this.messages[idx - 1]) return true;
      return (
        new Date(this.messages[idx - 1].createdAt).getDate() !==
        new Date(this.messages[idx].createdAt).getDate()
      );
    },
    isDeleted(message) {
      //si está borrado
      if (message.status === 'deleted') return true;
      //si no es mio, y el thread está baneado
      if (!message.mine && this.thread.status === 'banned') return true;
      //si no, normal
      return false;
    },
  },
  template: `
      <div class="messages-panel">
	      <div class="messages-header">
	        <div class="uk-grid uk-grid-small uk-flex-middle">
              <router-link to="/mensajes" class="uk-hidden@m">
                <i class="icon-chevron-left"></i>
              </router-link>
              <ThreadTitle class="uk-width-expand" :thread="thread" link="true"></ThreadTitle>
              <div>
                <button class="uk-button uk-button-ellipsis"></button>
                <div uk-dropdown="mode: click">
                  <ul class="uk-nav uk-dropdown-nav">
                    <li v-if="thread.status === 'publish'"><a @click="notify('archived', $event)">Archivar</a></li>
                    <li v-if="thread.status === 'archived'"><a @click="notify('publish', $event)">Desarchivar</a></li>
                    <li v-if="['publish', 'archived'].includes(thread.status)" class="uk-nav-divider"></li>
                    <li><a @click="notifyAlert('blocked', $event)">Bloquear</a></li>
                    <li><a @click="notifyAlert('spam', $event)">Denunciar</a></li>
                    <li class="uk-nav-divider"></li>
                    <li><a @click="notifyAlert('deleted', $event)" class="uk-text-danger">Borrar</a></li>
                  </ul>
                </div>
              </div>
	        </div>
	      </div>
	      <div class="messages-list">
	        <div v-for="(message, idx) in messages" :key="message._id">
	          <div class="date" v-if="isDifferentDate(idx)">
	            <span>{{ message.createdAt | dateFormat(defaultDateFormat) }}</span>
	          </div>
	          <div
	              :class="{ 'message': true, ['-'+message.type]: true, '-mine': message.mine, '-deleted': isDeleted(message) }">
	            <div class="meta">
	              <div class="actions" v-if="message.mine && message.status !== 'deleted'">
	                <button></button>
                    <div uk-dropdown="mode: click">
                      <ul class="uk-nav uk-dropdown-nav">
                        <li><a @click="remove(message)">Borrar</a></li>
                      </ul>
                    </div>
	              </div>
	              <div class="hour">{{message.createdAt | dateFormat('HH:mm') }}</div>
	            </div>
                <div v-if="isDeleted(message)">
                  Mensaje borrado
                </div>
                <div v-else-if="message.attachment" class="content -attachment">
                  <img v-if="message.type === 'image'" :src="message.attachment.url" :alt="message.content"/>
                  <a v-if="message.type !== 'image'" :href="message.attachment.url" target="_blank" class="download">
                    <strong>{{ message.attachment.originalname }}</strong><br>
                    <small>{{ message.attachment.size | fileSize }}</small>
                  </a>
                </div>
	            <div v-else class="content" v-html="$options.filters.autoLink(message.content)"></div>	            
	          </div>
	        </div>
          
          <div class="uk-alert uk-alert-danger" v-if="closedMessage">{{ closedMessage }}</div>
          
	        <div class="uk-alert" v-else-if="!canWrite">
	          Esperando para continuar la conversación.<br>
	          <small>
	            No puedes escribir hasta que la otra persona conteste.
            </small>
	        </div>
          
	      </div>
	      <div class="messages-input uk-flex" v-if="canWrite">
	        <input
	            type="text"
	            class="uk-input uk-width-expand"
	            :disabled="!canWrite"
	            v-model="content"
	            @keypress.enter="send(content)"
	        />
	        <uploader
	            :thread="thread._id"
                :disabled="!canWrite"
	            @file="upload($event)"
	        ></uploader>
	        <button
	            @click="send(content)"
	            :class="{'uk-disabled': !content}"
	            class="uk-button uk-button-send"
	        >Enviar
	        </button>
	      </div>
      </div>
	`,
};
